export default __webpack_public_path__ + "static/media/nittLogo.200fc918.png";